let containerRect;
let labelRect;
let labelWidth;
let labelRef;
let windowWidth;
let windowHeight;
let scrollX;
let scrollY;
let parentNode;
let offsetTop;
let offsetLeft;

function setPositionTop() {
  if (parentNode) {
    labelRef.style.top = `${offsetTop - labelRect.height}px`;
    labelRef.style.left = `${offsetLeft + containerRect.width / 2 - labelWidth / 2}px`;
  } else {
    if (containerRect.right - containerRect.width / 2 + labelWidth / 2 > document.documentElement.scrollWidth) {
      labelRef.style.right = 8 + 'px';
      labelRef.style.left = 'initial';
    } else {
      let left = scrollX + containerRect.left + containerRect.width / 2 - labelWidth / 2;
      if (left < 0) {
        left = 4;
      }
      labelRef.style.right = 'initial';
      labelRef.style.left = left + 'px';
    }
    labelRef.style.top = `${scrollY + containerRect.top - labelRect.height}px`;
  }
}

function setPositionRight() {
  if (parentNode) {
    labelRef.style.top = `${offsetTop + containerRect.height / 2 - labelRect.height / 2}px`;
    labelRef.style.left = `${offsetLeft + containerRect.width}px`;
  } else {
    labelRef.style.top = `${scrollY + containerRect.top - labelRect.height / 2 + containerRect.height / 2}px`;
    labelRef.style.left = `${scrollX + containerRect.right + 4}px`;
  }
}

function setPositionBottom() {
  if (parentNode) {
    labelRef.style.top = `${offsetTop + containerRect.height}px`;
    labelRef.style.left = `${offsetLeft + containerRect.width / 2 - labelWidth / 2}px`;
  } else {
    if (containerRect.right - containerRect.width / 2 + labelWidth / 2 > document.documentElement.scrollWidth) {
      labelRef.style.right = 8 + 'px';
      labelRef.style.left = 'initial';
    } else {
      let left = scrollX + containerRect.left + containerRect.width / 2 - labelWidth / 2;
      if (left < 0) {
        left = 4;
      }
      labelRef.style.right = 'initial';
      labelRef.style.left = left + 'px';
    }

    labelRef.style.top = `${scrollY + containerRect.bottom}px`;
  }
}

function setPositionLeft() {
  if (parentNode) {
    labelRef.style.top = `${offsetTop + containerRect.height / 2 - labelRect.height / 2}px`;
    labelRef.style.left = `${offsetLeft - labelWidth}px`;
  } else {
    labelRef.style.top = `${scrollY + containerRect.top - labelRect.height / 2 + containerRect.height / 2}px`;
    labelRef.style.left = `${scrollX + containerRect.left - labelWidth - 4}px`;
  }
}

export default function(parent, container, lblRef, position, maxWidth) {
  containerRect = container.getBoundingClientRect();
  lblRef.classList.add('uni-icon-label--is-shown');
  labelRect = lblRef.getBoundingClientRect();
  lblRef.classList.remove('uni-icon-label--is-shown');
  labelWidth = maxWidth ? maxWidth : labelRect.width;
  labelRef = lblRef;
  windowWidth = document.documentElement.scrollWidth;
  windowHeight = document.documentElement.scrollHeight;
  scrollX = window.scrollX;
  scrollY = window.scrollY;
  parentNode = parent;
  offsetTop = container.offsetTop;
  offsetLeft = container.offsetLeft;

  let newPosition;

  if (position === 'top') {
    if (containerRect.top > labelRect.height) {
      setPositionTop();
      newPosition = 'top';
    } else {
      setPositionBottom();
      newPosition = 'bottom';
    }
  } else if (position === 'right') {
    if (windowWidth - containerRect.right > labelRect.width) {
      setPositionRight();
      newPosition = 'right';
    } else {
      setPositionLeft();
      newPosition = 'left';
    }
  } else if (position === 'bottom') {
    if (windowHeight - containerRect.bottom > labelRect.height) {
      setPositionBottom();
      newPosition = 'bottom';
    } else {
      setPositionTop();
      newPosition = 'top';
    }
  } else if (position === 'left') {
    if (containerRect.left > labelRect.width) {
      setPositionLeft();
      newPosition = 'left';
    } else {
      setPositionRight();
      newPosition = 'right';
    }
  }

  return newPosition;
}



// WEBPACK FOOTER //
// ./src/__utils/iconLabelHelpers.js